import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { map, Observable, take, tap } from 'rxjs';
import { AuthService } from '@app/core/services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.authService.isLoggedIn$.pipe(
      take(1),
      tap((loggedIn) => {
        if (!loggedIn) {
          void this.router.navigate(['/auth/login']);
        }
      }),
      map((loggedIn) => loggedIn)
    );
  }

  canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }
}
